export const mobileRowGap = 12

export const desktopRowGap = 8

export const mobileRowHeight = 78 + mobileRowGap

export const desktopRowHeight = 39 + desktopRowGap
